<template>
	<div v-if="tyre.award_badges.length > 0" class="award-winning-badge">
        <img :src="badgePath" :alt="tyre.award_badges.length + ' Tyre Awards'" />
	</div>
</template>

<script>
    export default {
        props: ['tyre', 'siteName'],
        computed: {
            badgePath() {
                const imageUrl = this.tyre.image_url || '';
                const imageBaseUrl = imageUrl.includes('/Images/')
                    ? imageUrl.split('/Images/')[0]
                    : 'https://colewood-automotive.s3-eu-west-1.amazonaws.com';

                return imageBaseUrl + '/Images/awards/' + this.siteName + '_awards_' + this.tyre.award_badges.length + '.png';
            },
            tyreUrl() {
                return this.tyre.tyre_info_url.replace({'(': '', ')': '', '.': '-'});
            }
        }
    }
</script>

<style lang="scss" scoped>
    .award-winning-badge {
        position: absolute;
        top: 1%;
        right: 10%;
    }
</style>
